module.exports = __webpack_public_path__ + "static/media/streamlabs-logo-button.49584338.png";